import { computed, ref, watch } from '@vue/composition-api';
import { MapDataType, } from '@/components/Map/types';
import { useMapState } from '@/components/Map/composables/use-map-state';
import { ObjectStatusColor, ObjectCategory, } from '@/views/Brand/Applications/Offer/Details/constants';
export const useDataSetsDelivery = (props, ctx) => {
    const { settings } = useMapState();
    const { dataSets, setMarkers } = props;
    const deliveredDataSetsStatusMap = ref(new Map());
    const deliveredDataSets = ref(new Map());
    const getDeliverDataKey = (url) => url.split('/').join('-');
    const areAllDataSetsDelivered = computed(() => {
        const deliveredDataSetsArray = Array.from(deliveredDataSetsStatusMap.value.values());
        if (!dataSets) {
            return true;
        }
        return deliveredDataSetsArray.every((deliverDataSet) => deliverDataSet);
    });
    const setDeliveredDataStatus = (event, isDelivered) => {
        if (!event.url) {
            return;
        }
        // Vue does not react to the Map's set() method - assignment is necessary here to trigger watchers
        deliveredDataSetsStatusMap.value = new Map(deliveredDataSetsStatusMap.value.set(getDeliverDataKey(event.url), isDelivered));
        ctx.emit('data-status-change', areAllDataSetsDelivered.value);
    };
    const handleDataPending = (event) => {
        setDeliveredDataStatus(event, false);
    };
    const setDeliveredDataSet = (fetchedMapDataSet, dataSet) => {
        // Vue does not react to the Map's set() method - assignment is necessary here to trigger watchers
        deliveredDataSets.value = new Map(deliveredDataSets.value.set(getDeliverDataKey(fetchedMapDataSet.url), {
            dataSet,
            fetchedMapDataSet,
        }));
    };
    const categorizeObjects = (objects, categories) => {
        return objects.map((obj) => {
            const internalNumber = Number(obj.internalNumber);
            if (!internalNumber) {
                return obj;
            }
            let result = obj;
            if (categories.offer?.includes(internalNumber)) {
                result = {
                    ...obj,
                    category: ObjectCategory.Offer,
                    color: ObjectStatusColor.Offer,
                };
            }
            else if (categories.reservation?.includes(internalNumber)) {
                result = {
                    ...obj,
                    category: ObjectCategory.Reservation,
                    color: ObjectStatusColor.Reservation,
                };
            }
            else if (categories.contract?.includes(internalNumber)) {
                result = {
                    ...obj,
                    category: ObjectCategory.Contract,
                    color: ObjectStatusColor.Contract,
                };
            }
            return result;
        });
    };
    const handleDataDeliver = (fetchedMapDataSet, dataSet) => {
        let processedDataSet = fetchedMapDataSet;
        if (dataSet.categorizeObjects &&
            dataSet.type === MapDataType.OBJECT &&
            dataSet.objectCategories) {
            const objects = fetchedMapDataSet?.results || [];
            const categorizedObjects = categorizeObjects(objects, dataSet.objectCategories);
            processedDataSet = {
                ...fetchedMapDataSet,
                results: categorizedObjects,
            };
        }
        setDeliveredDataStatus(fetchedMapDataSet, true);
        setDeliveredDataSet(processedDataSet, dataSet);
        setMarkers({ fetchedMapDataSet: processedDataSet, dataSet });
    };
    const rerenderDeliveredDataSetsMarkers = () => {
        for (const { dataSet, fetchedMapDataSet, } of deliveredDataSets.value.values()) {
            setMarkers({ fetchedMapDataSet, dataSet, center: false });
        }
    };
    watch(settings, rerenderDeliveredDataSetsMarkers);
    return {
        handleDataPending,
        areAllDataSetsDelivered,
        handleDataDeliver,
    };
};
